<template>
  <card-panel :id="jobCode"
              :removable="false"
              :separatedHeader="false"
              :isUppercase="false"
              class="big-height jobs-card-panel"
              @click.native="goToJobDetailPage"
              @click.ctrl.native="openJobDetailPage"
              @click.meta.native="openJobDetailPage"
              @click.middle.native="openJobDetailPage">
    <div slot="header-name" class="header">
      <div class="job-title heading-3 paragraph-xl">{{ title }}</div>
      <p class="job-company-type paragraph-m">{{ companyType }}</p>
      <div>
        <div v-if="industry || area" class="job-base-info">
          <svg-icon name="industry" width="16" height="16"></svg-icon>
          <div class="text-wrapper">
            <span class="paragraph">{{ industry }}</span>
            <svg-icon v-if="area" name="arrow-right" width="3" height="15"></svg-icon>
            <span class="paragraph">{{ area }}</span>
          </div>
        </div>
        <div v-if="location" class="job-base-info">
          <svg-icon name="location" width="16" height="16"></svg-icon>
          <div class="text-wrapper">
            <span class="paragraph">{{ location }}</span>
          </div>
        </div>
        <div v-if="annualSalary" class="job-base-info">
          <svg-icon name="wallet" width="16" height="16"></svg-icon>
          <div class="text-wrapper">
            <span class="paragraph">{{ annualSalary }}</span>
          </div>
        </div>
      </div>
    </div>
    <div slot="content">
      <div class="job-description bullet-list-container" v-html="description"></div>
      <div class="view-job">
        <a v-translate class="primary-link paragraph">View job</a>
      </div>
    </div>
    <div slot="footer">
      <span class="paragraph-s is-flex">{{ postedOnDate }}</span>
    </div>
  </card-panel>
</template>

<script>

import 'top20common/distribution/icons/location';
import 'top20common/distribution/icons/wallet';
import 'top20common/distribution/icons/manager';
import 'top20common/distribution/icons/industry';
import 'top20common/distribution/icons/arrow-right';

import {identity, pickBy} from 'lodash';
import CardPanel from 'top20common/components/card-panel/CardPanel';
import formatter from 'top20common/distribution/services/formatter';

export default {
  props: {
    title: {type: String},
    jobCode: {type: String},
    companyType: {type: String},
    industry: {type: String},
    area: {type: String, default: ''},
    location: {type: String, default: ''},
    annualSalary: {type: String},
    description: {type: String},
    postedOnDate: {type: String}
  },
  computed: {
    jobTitleSlug() {
      return formatter.slugify(this.title);
    }
  },
  methods: {
    goToJobDetailPage() {
      this.setPreviousAnchor();
      let {source, utm_source, utm_medium, utm_campaign, utm_content} = this.$route.query;
      this.$router.push({
        name: 'job',
        params: {code: this.jobCode, title: this.jobTitleSlug},
        query: pickBy({source, utm_source, utm_medium, utm_campaign, utm_content}, identity)
      });
    },
    setPreviousAnchor() {
      this.$store.commit('mutatePreviousAnchorState', this.jobCode);
    },
    openJobDetailPage() {
      window.open(`/jobs/${this.jobCode}/${this.jobTitleSlug}`, '_blank');
    }
  },
  components: {
    CardPanel
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.jobs-card-panel.card-panel {
  cursor: pointer;
  height: 100%;

  &:hover {
    .job-title {
      text-decoration: none;
    }

    /deep/ a.primary-link {
      color: var(--primary);
      border-bottom: 1px solid var(--dark-gray-mid-opacity);
    }
  }

  .job-title {
    text-decoration: underline;
    margin-bottom: 10px;
    word-break: break-word;
  }

  .job-company-type,
  .job-base-info {
    margin-bottom: 15px;
  }

  .job-base-info {
    display: flex;
    align-items: center;

    /deep/ .svg-icon {
      margin-right: 15px;

      .fill {
        fill: var(--secondary);
      }
    }

    .text-wrapper {
      /deep/ .svg-icon {
        stroke: var(--gray);
        margin: 0 10px;
      }
    }
  }

  .job-description {
    overflow: hidden;
  }

  .view-job {
    margin-top: 10px;
  }

  /deep/ .header-card-panel {
    padding-bottom: 0;
  }

  /deep/ .content-card-panel {
    padding-top: 0;
  }

  /deep/ .card-footer {
    min-height: 32px;
    border-top: 1px solid var(--light-gray);
    padding: 7px 20px;
  }
}
</style>
